import React from 'react';
import {connect} from 'react-redux';
import {Flex, Jibber} from '/app/src/component';

import Item from './Item';
import AddNewCoworker from './AddNewCoworker'
import EmployeeSelector from '/app/src/model/Employee/selector';

import style  from './style.css'

class CompanySettingsEmployee extends Jibber {
    constructor(props){
        super(props);

        this.useState({
            screen: 'normal',
            itemSelected: -1,
            searchInput: '',
            removalModal: false
        })

        this._itemSelected = this._itemSelected.bind(this)
        this._renderList = this._renderList.bind(this)
        this._handleRemovalModal = this._handleRemovalModal.bind(this);

    }



    _itemSelected(id){
        return () => {
            this.setState({itemSelected: id})
        }
    }

    _renderList(){
        const ListComponents = [];
        this.props.coworkers.forEach((co) => {
            ListComponents.push(
                <Item
                    employee={co}
                    key={co.get('id')}
                    _onClick={this._itemSelected(co.get('id'))}
                    currentItem={this.state.itemSelected}
                    _handleRemovalModal={this._handleRemovalModal}
                />
            )
        })
        return ListComponents;
    }

    _handleRemovalModal(){
        this.setState({removalModal: !this.state.removalModal})
    }

    render() {
        return(
            <Flex column grow>
                <Flex column className={style.FAQItemList} grow>
                    <div style={{
                        'overflow': 'auto'
                    }}>
                        <AddNewCoworker
                            _onClick={this._itemSelected(0)}
                            currentItem={this.state.itemSelected}
                        />
                            {this._renderList()}
                    </div>
                </Flex>
            </Flex>
        );
    }

}

const mapStateToProps = (state, props) => ({
    coworkers: EmployeeSelector.getCoworkers(state)
})
export default connect(mapStateToProps)(CompanySettingsEmployee);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/CompanySettings/Employee/index.js